import { gql } from '@apollo/client';

import { ContactDataFragment } from '../fragments/ContactDataFragment';
import { PartnerBranchFragment } from '../fragments/PartnerBranchFragment';

export type {
  UpdatePartnerBranchMember as IUpdatePartnerBranchMember,
  UpdatePartnerBranchMemberVariables as IUpdatePartnerBranchMemberVariables,
  UpdatePartnerBranchMember_updatePartnerBranchMember as IPartnerBranchMemberData,
} from './__generated__/UpdatePartnerBranchMember';

export const UPDATE_PARTNER_BRANCH_MEMBER = gql`
  mutation UpdatePartnerBranchMember($branchID: String!) {
    updatePartnerBranchMember(branchId: $branchID) {
      ...PartnerBranchFragment
      partnerManagerContact {
        ...ContactDataFragment
      }
    }
  }
  ${PartnerBranchFragment}
  ${ContactDataFragment}
`;
